import React from 'react';
import { Gift } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  id: 1,
  title: 'Aromaterapia Fácil en 7 Minutos',
  desc: 'Mezclas simples con aceites esenciales.',
  img: 'https://cdn.magicpatterns.com/uploads/d6wuvX8RFGi9o5bupxw4HM/2c4637fe-1f6d-4a52-9743-42a05130cffa.png'
}, {
  id: 2,
  title: 'Baños Mágicos y Sahumerios',
  desc: 'Rituales naturales para cuerpo y energía.',
  img: 'https://cdn.magicpatterns.com/uploads/w1X6ed42JUf1Z62HxXiNEZ/ChatGPT_Image_22_may_2026,_00_40_01.png'
}, {
  id: 3,
  title: 'SOS 7 Días Antiinflamación',
  desc: 'Menú completo de 7 días.',
  img: 'https://cdn.magicpatterns.com/uploads/79rzUdSC39YehRV1P7Xkwe/ChatGPT_Image_22_may_2026,_00_42_46.png'
}, {
  id: 4,
  title: 'Guía Herbal Femenina',
  desc: 'Plantas aliadas para cada etapa.',
  img: 'https://cdn.magicpatterns.com/uploads/tUmJxSm5Uo22ve9k2yMPYM/ChatGPT_Image_22_may_2026,_00_43_55.png'
}, {
  id: 5,
  title: 'Botiquín Natural Infantil',
  desc: 'Remedios naturales pensados para niños.',
  img: 'https://cdn.magicpatterns.com/uploads/8DoJUC4SSoWBHDSCiUCvgu/ChatGPT_Image_22_may_2026,_00_45_27.png'
}, {
  id: 6,
  title: 'Kit de Urgencias Naturales',
  desc: '6 ingredientes esenciales con propiedades y usos.',
  img: 'https://cdn.magicpatterns.com/uploads/5hrLReBvZTmNaS63JzUoYb/ChatGPT_Image_22_may_2026,_00_57_44.png'
}, {
  id: 7,
  title: 'Belleza Herbal',
  desc: 'Recetas naturales para piel y pelo.',
  img: 'https://cdn.magicpatterns.com/uploads/gweP7JukoNyKKZ6gDLNM7q/ChatGPT_Image_22_may_2026,_00_46_38.png'
}, {
  id: 8,
  title: 'Cocina en 10 Minutos',
  desc: 'Comidas naturales fáciles y rápidas.',
  img: 'https://cdn.magicpatterns.com/uploads/47u2dodKPNkxZdoD2wmhuA/ChatGPT_Image_22_may_2026,_00_48_12.png'
}, {
  id: 9,
  title: 'Protocolos Express por Síntoma',
  desc: 'Acción inmediata: síntoma → solución.',
  img: 'https://cdn.magicpatterns.com/uploads/4KG9Q8NTQ3Dt213v8srbgK/ChatGPT_Image_22_may_2026,_00_49_29.png'
}, {
  id: 10,
  title: 'Kit de Urgencias Naturales',
  desc: '6 ingredientes esenciales en casa.',
  img: 'https://cdn.magicpatterns.com/uploads/nkCgYd2DCYUDu2WAD3VdcH/ChatGPT_Image_22_may_2026,_00_51_48.png'
}];
export function Bonuses() {
  return <section className="py-12 md:py-20 px-5 bg-cream-50" data-id="element-29">
      <div className="max-w-5xl mx-auto" data-id="element-30">
        {/* Header */}
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-31">
          <div className="inline-flex items-center gap-2 bg-terracotta-500/10 text-terracotta-600 px-4 py-1.5 rounded-full text-xs font-medium mb-5" data-id="element-32">
            <Gift className="w-3.5 h-3.5" data-id="element-33" />
            10 guías de regalo incluidas
          </div>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight mb-4" data-id="element-34">
            Y además,{' '}
            <span className="italic text-olive-600" data-id="element-35">10 guías digitales</span> de
            regalo
          </h2>
          <p className="text-ink-700 text-base md:text-lg leading-relaxed" data-id="element-36">
            Hoy se suman al pack para que tu biblioteca natural sea todavía más
            completa.
          </p>
        </div>

        {/* Compact bonus grid */}
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-5 mb-8 md:mb-12" data-id="element-37">
          {bonuses.map(bonus => <a key={bonus.id} href="https://impulsodigital.vip/cart/44742359646294:1" className="group block bg-cream-100 rounded-2xl overflow-hidden border border-cream-300 hover:border-olive-300 hover:shadow-lg transition-all" data-id="element-38">
              <div className="aspect-[3/4] overflow-hidden bg-cream-100 flex items-center justify-center p-3" data-id="element-39">
                <img src={bonus.img} alt={bonus.title} className="max-w-full max-h-full object-contain group-hover:scale-[1.04] transition-transform duration-500 drop-shadow-md" data-id="element-40" />
              </div>
              <div className="p-3 md:p-4" data-id="element-41">
                <p className="text-[10px] md:text-xs uppercase tracking-wider text-olive-600 font-semibold mb-1" data-id="element-42">
                  Regalo {bonus.id}
                </p>
                <h3 className="font-serif font-medium text-sm md:text-base text-ink-900 leading-tight mb-1" data-id="element-43">
                  {bonus.title}
                </h3>
                <p className="text-xs text-ink-600 leading-snug hidden md:block" data-id="element-44">
                  {bonus.desc}
                </p>
              </div>
            </a>)}
        </div>

        {/* Value summary */}
        <div className="bg-cream-100 border border-cream-300 rounded-2xl p-6 md:p-8 text-center max-w-2xl mx-auto" data-id="element-45">
          <p className="text-sm text-ink-700 mb-2" data-id="element-46">
            Valor real del pack completo
          </p>
          <p className="font-serif text-2xl md:text-3xl text-ink-900 line-through opacity-50 mb-1" data-id="element-47">
            $49.990 ARS
          </p>
          <p className="text-ink-700 mb-1" data-id="element-48">Hoy lo llevás por</p>
          <p className="font-serif text-4xl md:text-5xl font-semibold text-olive-700" data-id="element-49">
            $19.990 ARS
          </p>
        </div>
      </div>
    </section>;
}